<div class="app-container">
  <app-header class="header"></app-header>
  <div class="main">
    <app-sidebar [items]="navItems" class="sidebar"></app-sidebar>
    <div class="content-container">
      <div class="content-header">
        <div class="flex flex-between">
          <app-breadcrumbs
            class="breadcrumbs"></app-breadcrumbs>
          <div class="flex flex-between align-content-center" *ngIf="showFilterButtons()">
            <div style="margin-right: 16px" [ngStyle]="{'width': '16px', 'cursor': 'pointer'}" (mouseenter)="remove.show($event)" (mouseleave)="remove.hide()" (click)="resetFilter()"><med-icon-refresh [ngStyle]="{'width': '16px', 'cursor': 'pointer'}"></med-icon-refresh></div>
            <p-overlayPanel #remove>
              <div class="flex items-center h10-text">
                Скинути
              </div>
            </p-overlayPanel>
            <div class="h7-heading-14px-fontsize">Фільтр</div>
            <div class="h7-heading-14px-fontsize black-30" style="margin-left: 10px; margin-right: 10px">{{filterService.filtersCount(currentPath())}}</div>
            <div>
              <med-icon-filter [ngStyle]="{'width': '16px', 'cursor': 'pointer'}" (click)="showFilter()">
              </med-icon-filter>
            </div>
          </div>

        </div>
        <div *ngIf="filterService.suppliesPageHasFilters() && isPage('supplies')" class="flex gap-1" style="align-items: center">
          <div class="flex h10-text">Фільтри:</div>
          <med-bubble
            [styleClass]="''"
            *ngFor="let item of filterService.supplies.mnn; trackBy: trackByIndex"
            [visibleCloseBtn]="true" (click)="deleteSuppliesFilterItem(filterService.supplies.mnn, item)">
            {{ item }}
          </med-bubble>
          <med-bubble
            [styleClass]="''"
            *ngFor="let item of filterService.supplies.direction; trackBy: trackByIndex"
            [visibleCloseBtn]="true" (click)="deleteSuppliesFilterItem(filterService.supplies.direction, item)">
            {{ getDirectionLabel(item) }}
          </med-bubble>
          <med-bubble *ngIf="filterService.supplies.supplier.length && filterService.supplies.supplier[0]"
            [styleClass]="''"
            [visibleCloseBtn]="true" (click)="deleteSuppliesFilterItem(filterService.supplies.supplier, filterService.supplies.supplier[0])">
            {{ filterService.supplies.supplier[0] }}
          </med-bubble>
          <med-bubble
            [styleClass]="''"
            *ngFor="let item of filterService.supplies.subDirection; trackBy: trackByIndex"
            [visibleCloseBtn]="true" (click)="deleteSuppliesFilterItem(filterService.supplies.subDirection, item)">
            {{ item }}
          </med-bubble>
          <med-bubble
            [styleClass]="''"
            *ngFor="let item of filterService.supplies.status; trackBy: trackByIndex"
            [visibleCloseBtn]="true" (click)="deleteSuppliesFilterItem(filterService.supplies.status, item)">
            {{ item }}
          </med-bubble>
          <med-bubble *ngIf="filterService.supplies.agreementNum.length"
            [styleClass]="''"
            [visibleCloseBtn]="true" (click)="deleteSuppliesFilterItem(filterService.supplies.agreementNum, filterService.supplies.agreementNum[0])">
            {{ filterService.supplies.agreementNum[0] }}
          </med-bubble>
          <med-bubble
            [styleClass]="''"
            *ngFor="let item of filterService.supplies.warehouse; trackBy: trackByIndex"
            [visibleCloseBtn]="true" (click)="deleteSuppliesFilterItem(filterService.supplies.warehouse, item)">
            {{ item }}
          </med-bubble>
          <med-bubble *ngIf="filterService.supplies.actualDate && filterService.supplies.actualDate.length"
            [styleClass]="''"
            [visibleCloseBtn]="true" (click)="deleteFilterItemDate('actualDate')">
            {{ filterService.supplies.actualDate[0] | date: 'dd.MM.yyyy'}} -
            {{ filterService.supplies.actualDate[1] | date: 'dd.MM.yyyy'}}
          </med-bubble>
          <med-bubble *ngIf="filterService.supplies.expectedDate && filterService.supplies.expectedDate.length"
            [styleClass]="''"
            [visibleCloseBtn]="true" (click)="deleteFilterItemDate('expectedDate')">
            {{ filterService.supplies.expectedDate[0] | date: 'dd.MM.yyyy' }} -
            {{ filterService.supplies.expectedDate[1] | date: 'dd.MM.yyyy' }}
          </med-bubble>
        </div>
      </div>

      <div *ngIf="filterService.reservesPageHasFilters() && isPage('reserves') && !filterService.goodSpecificationsShowed" class="flex gap-1" style="align-items: center">
        <div class="flex h10-text">Фільтри:</div>
        <med-bubble *ngIf="filterService.reserves.lovId.length"
                    [styleClass]="''"
                    [visibleCloseBtn]="true" (click)="deleteReservesFilterItem(filterService.reserves.lovId, filterService.reserves.lovId[0])">
          {{ filterService.reserves.lovId[0] }}
        </med-bubble>
        <med-bubble *ngFor="let item of filterService.reserves.mnnId; trackBy: trackByIndex"
                    [styleClass]="''"
                    [visibleCloseBtn]="true" (click)="deleteFilterItem(filterService.reserves.mnnId, item)">
          {{ item }}
        </med-bubble>
        <med-bubble *ngFor="let item of filterService.reserves.direction; trackBy: trackByIndex"
                    [styleClass]="''"
                    [visibleCloseBtn]="true" (click)="deleteReservesFilterItem(filterService.reserves.direction, item)">
          {{ getDirectionLabel(item) }}
        </med-bubble>
        <med-bubble *ngFor="let item of filterService.reserves.mnn; trackBy: trackByIndex"
                    [styleClass]="''"
                    [visibleCloseBtn]="true" (click)="deleteReservesFilterItem(filterService.reserves.mnn, item)">
          {{ item }}
        </med-bubble>
        <med-bubble *ngIf="filterService.reserves.dosage.length && filterService.reserves.dosage[0]"
                    [styleClass]="''"
                    [visibleCloseBtn]="true" (click)="deleteReservesFilterItem(filterService.reserves.dosage, filterService.reserves.dosage[0])">
          {{ filterService.reserves.dosage[0] }}
        </med-bubble>
        <med-bubble *ngIf="filterService.reserves.measure.length && filterService.reserves.measure[0]"
                    [styleClass]="''"
                    [visibleCloseBtn]="true" (click)="deleteReservesFilterItem(filterService.reserves.measure, filterService.reserves.measure[0])">
          {{ filterService.reserves.measure[0] }}
        </med-bubble>
        <med-bubble *ngIf="filterService.reserves.reject.length"
                    [styleClass]="''"
                    [visibleCloseBtn]="true" (click)="deleteReservesFilterItem(filterService.reserves.reject, filterService.reserves.reject[0])">
          {{ filterService.reserves.reject[0] }}
        </med-bubble>

        <med-bubble *ngIf="filterService.reserves.availability.length && filterService.reserves.availability[0]"
                    [styleClass]="''"
                    [visibleCloseBtn]="true" (click)="deleteReservesFilterItem(filterService.reserves.availability, filterService.reserves.availability[0])">
          {{ filterService.reserves.availability[0] }}
        </med-bubble>
        <med-bubble *ngIf="filterService.reserves.documents.length"
                    [styleClass]="''"
                    [visibleCloseBtn]="true" (click)="deleteReservesFilterItem(filterService.reserves.documents, filterService.reserves.documents[0])">
          {{ filterService.reserves.documents[0] }}
        </med-bubble>
        <med-bubble *ngIf="filterService.reserves.subDirection.length && filterService.reserves.subDirection[0]"
                    [styleClass]="''"
                    [visibleCloseBtn]="true" (click)="deleteReservesFilterItem(filterService.reserves.subDirection, filterService.reserves.subDirection[0])">
          {{ filterService.reserves.subDirection[0] }}
        </med-bubble>
        <med-bubble *ngIf="filterService.reserves.controlDate && filterService.reserves.controlDate.length"
                    [styleClass]="''"
                    [visibleCloseBtn]="true" (click)="deleteFilterItemDate('controlDate')">
          {{ filterService.reserves.controlDate[0] | date: 'dd.MM.yyyy' }} -
          {{ filterService.reserves.controlDate[1] | date: 'dd.MM.yyyy' }}
        </med-bubble>
      </div>

        <div *ngIf="filterService.actionsPageHasFilters() && isPage('actions')" class="flex gap-1" style="align-items: center">
            <div class="flex h10-text">Фільтри:</div>
            <med-bubble *ngFor="let item of filterService.actions.actionTypes; trackBy: trackByIndex"
                        [styleClass]="''"
                        [visibleCloseBtn]="true" (click)="deleteFilterItemActions(filterService.actions.actionTypes, item)">
                {{ item }}
            </med-bubble>
            <med-bubble *ngIf="filterService.actions.createdAt.length"
                        [styleClass]="''"
                        [visibleCloseBtn]="true" (click)="filterService.actions.createdAt = []; filterService.actionsStateChanged()">
                {{ filterService.actions.createdAt[0] | date: 'dd.MM.yyyy' }} -
                {{ filterService.actions.createdAt[1] | date: 'dd.MM.yyyy' }}
            </med-bubble>
            <med-bubble *ngIf="filterService.actions.initiator.length"
                        [styleClass]="''"
                        [visibleCloseBtn]="true" (click)="deleteFilterItemActions(filterService.actions.initiator, filterService.actions.initiator[0])">
                {{ filterService.actions.initiator[0] }}
            </med-bubble>
        </div>

      <div *ngIf="filterService.distributionsMZUHasFilters() && isPage('distributions/mzu')" class="flex gap-1" style="align-items: center">
        <div class="flex h10-text">Фільтри:</div>
        <med-bubble *ngIf="filterService.distributionsMZU.lovId.length"
                    [styleClass]="''"
                    [visibleCloseBtn]="true" (click)="deleteFilterItemDistributionsMZU(filterService.distributionsMZU.lovId, filterService.distributionsMZU.lovId[0])">
          {{ filterService.distributionsMZU.lovId[0] }}
        </med-bubble>
        <med-bubble *ngIf="filterService.distributionsMZU.mnnId[0]"
                    [styleClass]="''"
                    [visibleCloseBtn]="true" (click)="deleteFilterItemDistributionsMZU(filterService.distributionsMZU.mnnId, filterService.distributionsMZU.mnnId[0])">
          {{ filterService.distributionsMZU.mnnId[0] }}
        </med-bubble>
        <med-bubble *ngIf="filterService.distributionsMZU.number[0]"
                    [styleClass]="''"
                    [visibleCloseBtn]="true" (click)="deleteFilterItemDistributionsMZU(filterService.distributionsMZU.number, filterService.distributionsMZU.number[0])">
          {{ filterService.distributionsMZU.number[0] }}
        </med-bubble>
        <med-bubble *ngIf="filterService.distributionsMZU.createdAt && filterService.distributionsMZU.createdAt.length"
                    [styleClass]="''"
                    [visibleCloseBtn]="true" (click)="deleteFilterItemDate('createdAt')">
          {{ filterService.distributionsMZU.createdAt[0] | date: 'dd.MM.yyyy' }} -
          {{ filterService.distributionsMZU.createdAt[1] | date: 'dd.MM.yyyy' }}
        </med-bubble>
        <med-bubble *ngIf="filterService.distributionsMZU.executor[0]"
                    [styleClass]="''"
                    [visibleCloseBtn]="true" (click)="deleteFilterItemDistributionsMZU(filterService.distributionsMZU.executor, filterService.distributionsMZU.executor[0])">
          {{ filterService.distributionsMZU.executor[0] }}
        </med-bubble>
        <med-bubble *ngFor="let status of filterService.distributionsMZU.status; trackBy: trackByIndex"
                    [styleClass]="''"
                    [visibleCloseBtn]="true" (click)="deleteFilterItemDistributionsMZU(filterService.distributionsMZU.status, status)">
          {{ translateStatus(status) }}
        </med-bubble>
        <med-bubble *ngIf="filterService.distributionsMZU.direction[0]"
                    [styleClass]="''"
                    [visibleCloseBtn]="true" (click)="deleteFilterItemDistributionsMZU(filterService.distributionsMZU.direction, filterService.distributionsMZU.direction[0])">
          {{ filterService.distributionsMZU.direction[0] }}
        </med-bubble>
        <med-bubble *ngIf="filterService.distributionsMZU.subDirection[0]"
                    [styleClass]="''"
                    [visibleCloseBtn]="true" (click)="deleteFilterItemDistributionsMZU(filterService.distributionsMZU.subDirection, filterService.distributionsMZU.subDirection[0])">
          {{ filterService.distributionsMZU.subDirection[0] }}
        </med-bubble>
        <med-bubble *ngIf="filterService.distributionsMZU.signs[0]"
                    [styleClass]="''"
                    [visibleCloseBtn]="true" (click)="deleteFilterItemDistributionsMZU(filterService.distributionsMZU.signs, filterService.distributionsMZU.signs[0])">
          {{ filterService.distributionsMZU.signs[0] }}
        </med-bubble>
        <med-bubble *ngIf="filterService.distributionsMZU.documents[0]"
                    [styleClass]="''"
                    [visibleCloseBtn]="true" (click)="deleteFilterItemDistributionsMZU(filterService.distributionsMZU.documents, filterService.distributionsMZU.documents[0])">
          {{ filterService.distributionsMZU.documents[0] }}
        </med-bubble>
        <med-bubble *ngIf="filterService.distributionsMZU.mnn[0]"
                    [styleClass]="''"
                    [visibleCloseBtn]="true" (click)="deleteFilterItemDistributionsMZU(filterService.distributionsMZU.mnn, filterService.distributionsMZU.mnn[0])">
          {{ filterService.distributionsMZU.mnn[0] }}
        </med-bubble>
        <med-bubble *ngIf="filterService.distributionsMZU.dosage[0]"
                    [styleClass]="''"
                    [visibleCloseBtn]="true" (click)="deleteFilterItemDistributionsMZU(filterService.distributionsMZU.dosage, filterService.distributionsMZU.dosage[0])">
          {{ filterService.distributionsMZU.dosage[0] }}
        </med-bubble>
        <med-bubble *ngIf="filterService.distributionsMZU.tradeName[0]"
                    [styleClass]="''"
                    [visibleCloseBtn]="true" (click)="deleteFilterItemDistributionsMZU(filterService.distributionsMZU.tradeName, filterService.distributionsMZU.tradeName[0])">
          {{ filterService.distributionsMZU.tradeName[0] }}
        </med-bubble>
        <med-bubble *ngIf="filterService.distributionsMZU.distributedQuantity[0]"
                    [styleClass]="''"
                    [visibleCloseBtn]="true" (click)="deleteFilterItemDistributionsMZU(filterService.distributionsMZU.distributedQuantity, filterService.distributionsMZU.distributedQuantity[0])">
          {{ filterService.distributionsMZU.distributedQuantity[0] }}
        </med-bubble>
        <med-bubble *ngIf="filterService.distributionsMZU.unitOfMeasure[0]"
                    [styleClass]="''"
                    [visibleCloseBtn]="true" (click)="deleteFilterItemDistributionsMZU(filterService.distributionsMZU.unitOfMeasure, filterService.distributionsMZU.unitOfMeasure[0])">
          {{ filterService.distributionsMZU.unitOfMeasure[0] }}
        </med-bubble>
        <med-bubble *ngIf="filterService.distributionsMZU.price[0]"
                    [styleClass]="''"
                    [visibleCloseBtn]="true" (click)="deleteFilterItemDistributionsMZU(filterService.distributionsMZU.price, filterService.distributionsMZU.price[0])">
          {{ filterService.distributionsMZU.price[0] }}
        </med-bubble>
        <med-bubble *ngIf="filterService.distributionsMZU.totalPrice[0]"
                    [styleClass]="''"
                    [visibleCloseBtn]="true" (click)="deleteFilterItemDistributionsMZU(filterService.distributionsMZU.totalPrice, filterService.distributionsMZU.totalPrice[0])">
          {{ filterService.distributionsMZU.totalPrice[0] }}
        </med-bubble>
        <med-bubble *ngIf="filterService.distributionsMZU.pdv[0]"
                    [styleClass]="''"
                    [visibleCloseBtn]="true" (click)="deleteFilterItemDistributionsMZU(filterService.distributionsMZU.pdv, filterService.distributionsMZU.pdv[0])">
          {{ filterService.distributionsMZU.pdv[0] }}
        </med-bubble>
        <med-bubble *ngIf="filterService.distributionsMZU.totalPdv[0]"
                    [styleClass]="''"
                    [visibleCloseBtn]="true" (click)="deleteFilterItemDistributionsMZU(filterService.distributionsMZU.totalPdv, filterService.distributionsMZU.totalPdv[0])">
          {{ filterService.distributionsMZU.totalPdv[0] }}
        </med-bubble>
        <med-bubble *ngIf="filterService.distributionsMZU.delivered[0]"
                    [styleClass]="''"
                    [visibleCloseBtn]="true" (click)="deleteFilterItemDistributionsMZU(filterService.distributionsMZU.delivered, filterService.distributionsMZU.delivered[0])">
          {{ filterService.distributionsMZU.delivered[0] }}
        </med-bubble>
        <med-bubble *ngIf="filterService.distributionsMZU.priceOfDeliveredWithPdv[0]"
                    [styleClass]="''"
                    [visibleCloseBtn]="true" (click)="deleteFilterItemDistributionsMZU(filterService.distributionsMZU.priceOfDeliveredWithPdv, filterService.distributionsMZU.priceOfDeliveredWithPdv[0])">
          {{ filterService.distributionsMZU.priceOfDeliveredWithPdv[0] }}
        </med-bubble>
        <med-bubble *ngIf="filterService.distributionsMZU.warehouse[0]"
                    [styleClass]="''"
                    [visibleCloseBtn]="true" (click)="deleteFilterItemDistributionsMZU(filterService.distributionsMZU.warehouse, filterService.distributionsMZU.warehouse[0])">
          {{ filterService.distributionsMZU.warehouse[0] }}
        </med-bubble>
        <med-bubble *ngIf="filterService.distributionsMZU.refusal[0]"
                    [styleClass]="''"
                    [visibleCloseBtn]="true" (click)="deleteFilterItemDistributionsMZU(filterService.distributionsMZU.refusal, filterService.distributionsMZU.refusal[0])">
          {{ filterService.distributionsMZU.refusal[0] }}
        </med-bubble>
        <med-bubble *ngIf="filterService.distributionsMZU.postponed[0]"
                    [styleClass]="''"
                    [visibleCloseBtn]="true" (click)="deleteFilterItemDistributionsMZU(filterService.distributionsMZU.postponed, filterService.distributionsMZU.postponed[0])">
          {{ filterService.distributionsMZU.postponed[0] }}
        </med-bubble>
      </div>

      <div *ngIf="filterService.recipientsDOZHasFilters() && isPage('recipients')" class="flex gap-1" style="align-items: center">
        <div class="flex h10-text">Фільтри:</div>
        <med-bubble *ngIf="filterService.recipientsDOZ.direction[0]"
                    [styleClass]="''"
                    [visibleCloseBtn]="true" (click)="deleteFilterItemRecipientsDOZ(filterService.recipientsDOZ.direction, filterService.recipientsDOZ.direction[0])">
          {{ filterService.recipientsDOZ.direction[0] }}
        </med-bubble>
        <med-bubble *ngIf="filterService.recipientsDOZ.shortListed[0]"
                    [styleClass]="''"
                    [visibleCloseBtn]="true" (click)="deleteFilterItemRecipientsDOZ(filterService.recipientsDOZ.shortListed, filterService.recipientsDOZ.shortListed[0])">
          {{ filterService.recipientsDOZ.shortListed[0] }}
        </med-bubble>
        <med-bubble *ngIf="filterService.recipientsDOZ.experts[0]"
                    [styleClass]="''"
                    [visibleCloseBtn]="true" (click)="deleteFilterItemRecipientsDOZ(filterService.recipientsDOZ.experts, filterService.recipientsDOZ.experts[0])">
          {{ filterService.recipientsDOZ.experts[0] }}
        </med-bubble>
      </div>

      <div *ngIf="filterService.recipientsMZUHasFilters() && isPage('recipients')" class="flex gap-1" style="align-items: center">
        <div class="flex h10-text">Фільтри:</div>
        <med-bubble *ngIf="filterService.recipientsMZU.direction[0]"
                    [styleClass]="''"
                    [visibleCloseBtn]="true" (click)="deleteFilterItemRecipientsMZU(filterService.recipientsMZU.direction, filterService.recipientsMZU.direction[0])">
          {{ filterService.recipientsMZU.direction[0] }}
        </med-bubble>
        <med-bubble *ngIf="filterService.recipientsMZU.shortListed[0]"
                    [styleClass]="''"
                    [visibleCloseBtn]="true" (click)="deleteFilterItemRecipientsMZU(filterService.recipientsMZU.shortListed, filterService.recipientsMZU.shortListed[0])">
          {{ filterService.recipientsMZU.shortListed[0] }}
        </med-bubble>
        <med-bubble *ngIf="filterService.recipientsMZU.responsibleForDirection[0]"
                    [styleClass]="''"
                    [visibleCloseBtn]="true" (click)="deleteFilterItemRecipientsMZU(filterService.recipientsMZU.responsibleForDirection, filterService.recipientsMZU.responsibleForDirection[0])">
          {{ filterService.recipientsMZU.responsibleForDirection[0] }}
        </med-bubble>
      </div>

      <div *ngIf="filterService.organizationsMZUHasFilters() && isPage('organizations')" class="flex gap-1" style="align-items: center">
        <div class="flex h10-text">Фільтри:</div>
        <med-bubble *ngIf="filterService.organizationsMZU.directions[0]"
                    [styleClass]="''"
                    [visibleCloseBtn]="true" (click)="deleteFilterItemOrganizationsItem(filterService.organizationsMZU.directions, filterService.organizationsMZU.directions[0])">
          {{ filterService.organizationsMZU.directions[0] }}
        </med-bubble>
        <med-bubble *ngIf="filterService.organizationsMZU.district[0]"
                    [styleClass]="''"
                    [visibleCloseBtn]="true" (click)="deleteFilterItemOrganizationsItem(filterService.organizationsMZU.district, filterService.organizationsMZU.district[0])">
          {{ filterService.organizationsMZU.district[0] }}
        </med-bubble>
        <med-bubble *ngIf="filterService.organizationsMZU.name[0]"
                    [styleClass]="''"
                    [visibleCloseBtn]="true" (click)="deleteFilterItemOrganizationsItem(filterService.organizationsMZU.name, filterService.organizationsMZU.name[0])">
          {{ filterService.organizationsMZU.name[0] }}
        </med-bubble>
        <med-bubble *ngIf="filterService.organizationsMZU.edrpou[0]"
                    [styleClass]="''"
                    [visibleCloseBtn]="true" (click)="deleteFilterItemOrganizationsItem(filterService.organizationsMZU.edrpou, filterService.organizationsMZU.edrpou[0])">
          {{ filterService.organizationsMZU.edrpou[0] }}
        </med-bubble>
        <med-bubble *ngIf="filterService.organizationsMZU.shortName[0]"
                    [styleClass]="''"
                    [visibleCloseBtn]="true" (click)="deleteFilterItemOrganizationsItem(filterService.organizationsMZU.shortName, filterService.organizationsMZU.shortName[0])">
          {{ filterService.organizationsMZU.shortName[0] }}
        </med-bubble>
        <med-bubble *ngIf="filterService.organizationsMZU.address[0]"
                    [styleClass]="''"
                    [visibleCloseBtn]="true" (click)="deleteFilterItemOrganizationsItem(filterService.organizationsMZU.address, filterService.organizationsMZU.address[0])">
          {{ filterService.organizationsMZU.address[0] }}
        </med-bubble>
        <med-bubble *ngIf="filterService.organizationsMZU.email[0]"
                    [styleClass]="''"
                    [visibleCloseBtn]="true" (click)="deleteFilterItemOrganizationsItem(filterService.organizationsMZU.email, filterService.organizationsMZU.email[0])">
          {{ filterService.organizationsMZU.email[0] }}
        </med-bubble>
        <med-bubble *ngIf="filterService.organizationsMZU.manager[0]"
                    [styleClass]="''"
                    [visibleCloseBtn]="true" (click)="deleteFilterItemOrganizationsItem(filterService.organizationsMZU.manager, filterService.organizationsMZU.manager[0])">
          {{ filterService.organizationsMZU.manager[0] }}
        </med-bubble>
        <med-bubble *ngIf="filterService.organizationsMZU.responsiblePersons[0]"
                    [styleClass]="''"
                    [visibleCloseBtn]="true" (click)="deleteFilterItemOrganizationsItem(filterService.organizationsMZU.responsiblePersons, filterService.organizationsMZU.responsiblePersons[0])">
          {{ filterService.organizationsMZU.responsiblePersons[0] }}
        </med-bubble>
        <med-bubble *ngIf="filterService.organizationsMZU.level[0]"
                    [styleClass]="''"
                    [visibleCloseBtn]="true" (click)="deleteFilterItemOrganizationsItem(filterService.organizationsMZU.level, filterService.organizationsMZU.level[0])">
          {{ filterService.organizationsMZU.level[0] }}
        </med-bubble>
        <med-bubble *ngIf="filterService.organizationsMZU.type[0]"
                    [styleClass]="''"
                    [visibleCloseBtn]="true" (click)="deleteFilterItemOrganizationsItem(filterService.organizationsMZU.type, filterService.organizationsMZU.type[0])">
          {{ filterService.organizationsMZU.type[0] }}
        </med-bubble>
        <med-bubble *ngIf="filterService.organizationsMZU.status[0]"
                    [styleClass]="''"
                    [visibleCloseBtn]="true" (click)="deleteFilterItemOrganizationsItem(filterService.organizationsMZU.status, filterService.organizationsMZU.status[0])">
          {{ filterService.organizationsMZU.status[0] }}
        </med-bubble>
      </div>

      <div *ngIf="filterService.distributionsDOZHasFilters() && isPage('distributions/doz')" class="flex gap-1" style="align-items: center">
        <div class="flex h10-text">Фільтри:</div>
        <med-bubble *ngIf="filterService.distributionsDOZ.number[0]"
                    [styleClass]="''"
                    [visibleCloseBtn]="true" (click)="deleteFilterItemDistributionsDOZ(filterService.distributionsDOZ.number, filterService.distributionsDOZ.number[0])">
          {{ filterService.distributionsDOZ.number[0] }}
        </med-bubble>
        <med-bubble *ngIf="filterService.distributionsDOZ.createdAt && filterService.distributionsDOZ.createdAt.length"
                    [styleClass]="''"
                    [visibleCloseBtn]="true" (click)="deleteFilterItemDate('createdAt')">
          {{ filterService.distributionsDOZ.createdAt[0] | date: 'dd.MM.yyyy' }} -
          {{ filterService.distributionsDOZ.createdAt[1] | date: 'dd.MM.yyyy' }}
        </med-bubble>
        <med-bubble *ngFor="let status of filterService.distributionsDOZ.status; trackBy: trackByIndex"
                    [styleClass]="''"
                    [visibleCloseBtn]="true" (click)="deleteFilterItemDistributionsDOZ(filterService.distributionsDOZ.status, status)">
          {{ translateStatus(status) }}
        </med-bubble>
        <med-bubble *ngIf="filterService.distributionsDOZ.direction[0]"
                    [styleClass]="''"
                    [visibleCloseBtn]="true" (click)="deleteFilterItemDistributionsDOZ(filterService.distributionsDOZ.direction, filterService.distributionsDOZ.direction[0])">
          {{ filterService.distributionsDOZ.direction[0] }}
        </med-bubble>
        <med-bubble *ngIf="filterService.distributionsDOZ.subDirection[0]"
                    [styleClass]="''"
                    [visibleCloseBtn]="true" (click)="deleteFilterItemDistributionsDOZ(filterService.distributionsDOZ.subDirection, filterService.distributionsDOZ.subDirection[0])">
          {{ filterService.distributionsDOZ.subDirection[0] }}
        </med-bubble>
        <med-bubble *ngIf="filterService.distributionsDOZ.mnn[0]"
                    [styleClass]="''"
                    [visibleCloseBtn]="true" (click)="deleteFilterItemDistributionsDOZ(filterService.distributionsDOZ.mnn, filterService.distributionsDOZ.mnn[0])">
          {{ filterService.distributionsDOZ.mnn[0] }}
        </med-bubble>
        <med-bubble *ngIf="filterService.distributionsDOZ.distributedQuantity[0]"
                    [styleClass]="''"
                    [visibleCloseBtn]="true" (click)="deleteFilterItemDistributionsDOZ(filterService.distributionsDOZ.distributedQuantity, filterService.distributionsDOZ.distributedQuantity[0])">
          {{ filterService.distributionsDOZ.distributedQuantity[0] }}
        </med-bubble>
      </div>

      <div class="content">
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
</div>

<med-notification
        position="top-right"
        [lifeTime]="10000"
        [closable]="true"
></med-notification>

<med-tooltip-content></med-tooltip-content>

<med-popup-content></med-popup-content>
